import React, { PureComponent, MouseEvent } from 'react';
import b from 'b_';

import './theme-page-header.css';

import Breadcrumbs from '@components/breadcrumbs';
import { BreadcrumbItem } from '@components/breadcrumbs/breadcrumbs';
import ThemeHeader from '@components/theme-header';
import Theme from '@interfaces/themes';
import PublicationsFilterYear from '@components/publications-year-filter';

interface Props {
    theme: Theme;
    year?: string | null;
    onYearChange(year?: number): void;
}

const class_ = b.with('theme-header-page');

export default class ThemePageHeader extends PureComponent<Props> {
    public render() {
        const { theme, year, onYearChange } = this.props;
        const { title, slug } = theme || ({} as any);
        const breadcrumbs: BreadcrumbItem[] = [{ text: 'Publications', url: '/publications' }];

        if (year) {
            breadcrumbs.push(
                {
                    text: title,
                    url: `/publications/?themeSlug=${slug}`,
                    onClick: (_event: MouseEvent) => onYearChange()
                },
                { text: year.toString() }
            );
        } else {
            breadcrumbs.push({ text: title });
        }

        return (
            <div className={class_()}>
                <Breadcrumbs items={breadcrumbs} />

                <ThemeHeader
                    theme={theme}
                    className={class_('header')}
                >
                    <div className={class_('year-filter')}>
                        <PublicationsFilterYear
                            themeSlug={theme.slug}
                            onYearChange={onYearChange}
                            selectedYear={year}
                        />
                    </div>
                </ThemeHeader>
            </div>
        );
    }
}
